/**
 * Agrégateur de paiement en ligne actif (checkout).
 * Valeurs : "fedapay" | "kkiapay"
 * Source unique : src/config/env.js
 */
import { PAYMENT_ONLINE_PROVIDER } from "./env";

export const getOnlinePaymentProvider = () => PAYMENT_ONLINE_PROVIDER;

export const isFedaPayProvider = () =>
  getOnlinePaymentProvider() === "fedapay";

export const isKkiapayProvider = () =>
  getOnlinePaymentProvider() === "kkiapay";
